import { call, put, takeLatest } from 'redux-saga/effects';

import { HealthPlan } from '@models/HealthPlan';
import { HealthPlanApi } from '@apis/HealthPlanApi';

import {
  healthPlansFetch,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleHealthPlansFetch() {
  const state: StateUpdatePayload = { healthPlans: [] };
  try {
    state.healthPlans = (yield call(HealthPlanApi.getAll)) as HealthPlan[];
    yield put(stateUpdate(state));
  } catch { }
}

export default function* () {
  yield takeLatest(healthPlansFetch, handleHealthPlansFetch);
}
